const defaultEnvironment = "development";
const nodeEnv = process.env.NODE_ENV;

const configuration = {
  test: {
    tpmHost: "https://test-tpm-server.sp.org"
  },
  development: {
    tpmHost: "http://tpm-integration.vigetx.com",
    cdnHost: ""
  },
  integration: {
    tpmHost: "http://tpm-integration.vigetx.com",
    cdnHost: "http://nthp-thisplacematters-widget.s3.amazonaws.com/integration"
  },
  feature: {
    tpmHost: "http://tpm-integration.vigetx.com",
    cdnHost: "http://nthp-thisplacematters-widget.s3.amazonaws.com/feature"
  },
  staging: {
    tpmHost: "https://tpm-staging.savingplaces.org",
    cdnHost: "https://nthp-thisplacematters-widget.s3.amazonaws.com/staging"
  },
  production: {
    tpmHost: "https://tpm.savingplaces.org",
    cdnHost: "https://nthp-thisplacematters-widget.s3.amazonaws.com/production"
  }
};

export const environment = nodeEnv ? nodeEnv : defaultEnvironment;
export const environmentConfiguration = configuration[environment];
export default environmentConfiguration;



/** WEBPACK FOOTER **
 ** ./config/environment.js
 **/